import React, {useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Waiting from './Waiting';

import useMediaQuery from '@mui/material/useMediaQuery';
import useStyles from '../styles/Styles';

import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

import { courseWithdrawalRequest, undoCourseWithdrawalRequest, resetErrorMessage } from '../actions';
import { indefiniteArticle } from '../utils';

const EnrolmentWithdrawalDialog = ({course, courseLabels, setRemovalRequestOpen, undoingRemoval}) => {
	const classes = useStyles();
	const isSm = useMediaQuery('(min-width:650px)');
	
	const dispatch = useDispatch();
	const [submitted, setSubmitted] = useState(false);
	const request = useSelector(state => state.requests.course_withdrawal);
	const undo_request = useSelector(state => state.requests.undo_course_withdrawal);
	
	const closeDialog = () => {
		dispatch(resetErrorMessage());
		setRemovalRequestOpen(false);
		setSubmitted(false);
	}
	
	const submitRequest = () => {
		dispatch(resetErrorMessage());
		setSubmitted(true);
		if(undoingRemoval){
			dispatch(undoCourseWithdrawalRequest(course.course_code));
		} else {
			dispatch(courseWithdrawalRequest(course.course_code));
		}
	}

	const SubmitResult = () => {
		if(undoingRemoval){
			if(undo_request.submitting){
				return <DialogContent dividers>
					<Waiting message='Cancelling withdrawal request. Please wait...' />
					</DialogContent>
			} else if(submitted && undo_request.sent){
				return <>
				<DialogContent dividers>
					<Typography variant='h6' component='h3' gutterBottom>Withdrawal request cancelled</Typography>
					<Typography paragraph>Your {courseLabels.courseLabel} withdrawal request for <strong>{course.course_name} ({course.course_code})</strong> has been cancelled.</Typography>
					
				</DialogContent>
				<DialogActions>
					<Button onClick={() => closeDialog()} color="primary">Close</Button>
				</DialogActions>
				</>
			} else if(submitted && undo_request.message) {
				return <>
				<DialogContent dividers>
					<Typography variant='h6' component='h3' gutterBottom>Error</Typography>
					<Typography paragraph>Failed to cancel withdrawal request.</Typography>
					<Typography paragraph>{request.message}</Typography>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => closeDialog()} color="primary">
						Close
					 </Button>
				</DialogActions>
				</>;
			} else {
				return <DialogContent dividers></DialogContent>
			}
		} else {
			if(request.submitting){
				return <DialogContent dividers>
					<Waiting message='Submitting withdrawal request. Please wait...' />
					</DialogContent>
			} else if(submitted && request.sent){
				return <>
				<DialogContent dividers>
					<Typography variant='h6' component='h3' gutterBottom>Withdrawal request submitted</Typography>
					<Typography paragraph>Your {courseLabels.courseLabel} withdrawal request for <strong>{course.course_name} ({course.course_code})</strong> has been submitted. {indefiniteArticle(courseLabels.courseLabel, true)} administrator will action your request as soon as practicable.</Typography>
					
				</DialogContent>
				<DialogActions>
					<Button onClick={() => closeDialog()} color="primary">Close</Button>
				</DialogActions>
				</>
			} else if(submitted && request.message) {
				return <>
				<DialogContent dividers>
					<Typography variant='h6' component='h3' gutterBottom>Error</Typography>
					<Typography paragraph>Failed to submit withdrawal request.</Typography>
					<Typography paragraph>{request.message}</Typography>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => closeDialog()} color="primary">
						Close
					</Button>
				</DialogActions>
				</>;
			} else {
				return <DialogContent dividers></DialogContent>
			}
	 	}  
	}
	
	return (
	<Dialog
		open={course !== false}
		onClose={() => closeDialog()}
		fullScreen={!isSm}
		className={classes.settingsDialog}
	>
	<DialogTitle>{undoingRemoval ? 'Cancel ' : null}{courseLabels.courseCapLabel} Withdrawal Request</DialogTitle>
	{course ? 
	(submitted ? <SubmitResult /> : <>
	<DialogContent dividers>
		<Typography variant="h6" gutterBottom>Are you sure?</Typography>
		<Typography>To {undoingRemoval ? 'cancel your ' : null}request to be withdrawn from <strong>{course.course_name} ({course.course_code})</strong>, use the SUBMIT button below.
		{undoingRemoval ? null : ' Your request will be sent to '+indefiniteArticle(courseLabels.courseLabel)+' administrator.'}
		</Typography>
	</DialogContent>
	<DialogActions>
		<Button color="primary" variant="outlined" 
			size={isSm ? 'medium' : 'small'}
			onClick={() => { closeDialog() }}
		>Cancel</Button>
		<Button variant='contained' color="primary"
			onClick={() => submitRequest()} 
		>Submit</Button>
	</DialogActions>
	</>) : null }
	</Dialog>
)}

export default EnrolmentWithdrawalDialog;